import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { firm, resultsDisclaimer } from "../../data/site";
import { SiteLink } from "../SiteLink";
import { VerdictVideo } from "./VerdictVideo";
export function CaseResult() {
  return <section id="case-result" aria-labelledby="result-title" className="on-dark bg-ink text-white" data-id="element-166" data-mp="ijdnmqtlbqbx">
      <div className="page-container verdict-grid" data-id="element-167" data-mp="nd847ldwfp6s">
        <div data-id="element-168" data-mp="sb9jdv87f4cz">
          <p className="eyebrow text-white" data-id="element-169" data-mp="sbje1w471zp0">Featured Case Study</p>
          <h2 id="result-title" className="mt-3 font-extrabold leading-[1.1] tracking-tight" data-id="element-170" data-mp="x9t63xumgk6e">
            Behind the $27.5 million motorcycle verdict
          </h2>
          <p className="mt-4 text-[23px] font-bold leading-snug" data-id="element-171" data-mp="11c7oyhyajjxo">Motorcycle injury jury verdict</p>
          <p className="mt-2 text-meta text-white/90" data-id="element-172" data-mp="169q1eibiohaf">Kent County, Michigan · May 3, 2024</p>
          <p className="mt-5 max-w-measure text-meta text-white/80" data-id="element-173" data-mp="334cexnw8c75r">
            The firm’s case report describes it as Michigan’s largest motorcycle injury verdict, based on its research.
          </p>
          <h3 className="mt-7 text-h3 font-bold" data-id="element-174" data-mp="241xyfl8mz63d">Holding a distracted driver accountable</h3>
          <p className="mt-4 max-w-measure text-white/90" data-id="element-175" data-mp="1z8dayn4o5uif">
            A driver using a phone app crossed the centerline and struck a rider, whose injuries included a leg amputation.{" "}
            {firm.displayName} led the trial team for the rider and his wife, pursuing claims against the driver and her employer.
          </p>
          <SiteLink path="/27-million-motorcycle-injury-verdict/" className="mt-5 inline-flex min-h-[48px] items-center gap-2 text-label font-bold text-white underline underline-offset-4 hover:decoration-2" data-id="element-176" data-mp="2mx664hdgvybz">
            Read the full case study
            <ArrowRightIcon aria-hidden="true" className="h-5 w-5 shrink-0" data-id="element-177" data-mp="28yofaas9m5pu" />
          </SiteLink>
          <p className="mt-5 max-w-measure border-t border-white/25 pt-4 text-meta text-white/80" data-id="element-178" data-mp="12kp10serh89y">{resultsDisclaimer}</p>
        </div>
        <VerdictVideo data-id="element-179" data-mp="xmnkof8pzn26" />
      </div>
    </section>;
}